import Emitter from "./emitter";

export function alertMessage(
	type: "success" | "error" | "warning" | "info",
	message: string,
	description: string = ""
) {
	Emitter.emit("alert", {
		type: type,
		message: message,
		description: description,
		top: top,
		closeable: false,
		timeout: 3000,
	});
}
